import { Check, Eye, RotateCcw, X } from 'lucide-react';

function formatDate(value) {
  if (!value) return 'Kein Datum';
  return new Intl.DateTimeFormat('de-DE', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}

function excerpt(text, max = 150) {
  if (!text) return '';
  const normalized = String(text).replace(/\s+/g, ' ').trim();
  return normalized.length > max ? `${normalized.slice(0, max - 1)}...` : normalized;
}

export default function ArticleCard({ article, checked, onToggle, onStatus, onOpen }) {
  const region = article.region?.split(',')[0] || 'Allgemein';
  const isRejected = article.status === 'rejected';
  const isSelected = article.status === 'selected' || checked;

  return (
    <article className={`article-card status-${article.status}`}>
      <div className="article-image">
        {article.image_url ? <img src={article.image_url} alt="" loading="lazy" /> : <span>{region}</span>}
      </div>
      <div className="article-body">
        <div className="card-meta">
          <span className="region-badge">{region}</span>
          <span className="source-name">{article.source_name}</span>
        </div>
        <h2>{excerpt(article.title, 90)}</h2>
        <p>{excerpt(article.summary, 155)}</p>
        <time>{formatDate(article.published_at || article.created_at)}</time>
      </div>
      <div className="card-actions">
        <button className={isSelected ? 'selected-button' : 'secondary-button'} onClick={onToggle} type="button">
          <Check size={16} />
          <span>{isSelected ? 'Selected' : 'Select'}</span>
        </button>
        <button className="icon-button" onClick={onOpen} type="button" title="Details">
          <Eye size={17} />
        </button>
        <button
          className={isRejected ? 'danger-button active' : 'icon-button'}
          onClick={() => onStatus(isRejected ? 'new' : 'rejected')}
          type="button"
          title={isRejected ? 'Zuruecksetzen' : 'Ablehnen'}
        >
          {isRejected ? <RotateCcw size={17} /> : <X size={17} />}
        </button>
      </div>
    </article>
  );
}
